import type { WorkbookState } from 'cadenza/workbook/workbook.state';
import { getWorkbookName, isWorkbookVisibilityRestricted } from 'cadenza/workbook/workbook.state';
import { cadenzaSessionStorage } from 'cadenza/utils/storage/storage';
import { PARAMETER_OPERATION_MODE } from 'cadenza/api-client/published-api-constants';
import type { RootStateOr } from 'cadenza/store/cadenza-store';

type OperationMode = 'simplified' | 'normal';

export function isOperationModeSimplified(state: RootStateOr<WorkbookState>) {
  return getOperationMode(state) === 'simplified';
}

function getOperationMode(state: RootStateOr<WorkbookState>) {
  if (isWorkbookVisibilityRestricted(state)) {
    return 'simplified';
  }
  return loadOperationMode(state) ?? 'normal';
}

function loadOperationMode(state: RootStateOr<WorkbookState>) {
  return (
    ((new URLSearchParams(location.search).get(PARAMETER_OPERATION_MODE) ??
      cadenzaSessionStorage.getItem(operationModeKey(state))) as OperationMode | undefined) ?? undefined
  );
}

export function saveOperationMode(state: RootStateOr<WorkbookState>, operationMode = getOperationMode(state)) {
  // Safety check, if user has visibility restricted, then he cannot set 'normal' operation mode
  if (isWorkbookVisibilityRestricted(state)) {
    operationMode = 'simplified';
  }
  cadenzaSessionStorage.setItem(operationModeKey(state), operationMode);
}

function operationModeKey(state: RootStateOr<WorkbookState>) {
  return `workbook-operation-mode-${getWorkbookName(state)}`;
}
